import type { NavTabId } from "../../lib/layoutOrderStorage";
import type {
  SurfaceCapabilities,
  SurfaceNavTab,
} from "../../lib/surface-capabilities";
import type { SidebarIconName } from "./SidebarNavItem";

export type NavTab = SurfaceNavTab;

export interface SidebarNavDefinition {
  id: NavTab;
  icon: SidebarIconName;
  label: string;
  description: string;
}

type PrimaryNavTabId = Exclude<
  NavTabId,
  "feed" | "narrative" | "apparatus" | "proposals" | "performance" | "settings"
>;

export const NAV_ITEMS_MAP: Record<PrimaryNavTabId, SidebarNavDefinition> = {
  dashboard: {
    id: "dashboard",
    icon: "users",
    label: "Desk",
    description: "KPIs, calendar, RiskFlow",
  },
  analysis: {
    id: "analysis",
    icon: "landmark",
    label: "Consilium",
    description: "Narrative analytics center",
  },
  scouts: {
    id: "scouts",
    icon: "bot",
    label: "Scouts",
    description: "Automations & runs",
  },
  riskflow: {
    id: "riskflow",
    icon: "newspaper",
    label: "RiskFlow",
    description: "Market news & events",
  },
  econ: {
    id: "econ",
    icon: "calendar",
    label: "Calendar",
    description: "Economic calendar",
  },
};

export function getOrderedSidebarItems({
  order,
  capabilities,
}: {
  order: NavTabId[];
  capabilities?: SurfaceCapabilities;
}) {
  return order
    .filter(
      (id): id is PrimaryNavTabId =>
        id in NAV_ITEMS_MAP &&
        id !== "performance" &&
        (capabilities?.allowedTabs.includes(id as NavTab) ?? true),
    )
    .map((tabId) => ({ tabId, ...NAV_ITEMS_MAP[tabId] }));
}

export function sidebarGreeting() {
  const h = new Date().getHours();
  if (h < 12) return "Ave. The markets stir.";
  if (h < 17) return "The forum is active.";
  return "The day's battles are done.";
}
